import type { ThemeConfig } from 'antd';

// Helper function to get CSS variable value
const getCSSVariable = (variable: string): string => {
  if (typeof document !== 'undefined') {
    return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
  }
  return '';
};

// Function to create theme from CSS variables
export const createTheme = (): ThemeConfig => {
  return {
    token: {
      // Design tokens - these control global styling
      colorPrimary: getCSSVariable('--primary-color') || 'rgb(32, 83, 140)',
      colorBgLayout: getCSSVariable('--background-color') || 'rgb(250, 250, 250)',
      colorBgContainer: getCSSVariable('--textfield-background-color') || '#ffffff',
      colorText: getCSSVariable('--text-color') || '#000000',
      colorLink: getCSSVariable('--link-color') || '#005DAB',
      colorBorder: getCSSVariable('--border-color') || '#E7E7E7',
      fontSize: 14,
      borderRadius: 6,
      borderRadiusLG: 20,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    },
    components: {
      // Component-specific overrides
      Layout: {
        bodyBg: getCSSVariable('--background-color') || 'rgb(250, 250, 250)',
        headerBg: getCSSVariable('--primary-color') || 'rgb(32, 83, 140)',
        siderBg: getCSSVariable('--primary-color') || 'rgb(32, 83, 140)',
      },
      Button: {
        colorPrimary: getCSSVariable('--primary-color') || 'rgb(32, 83, 140)',
      },
      Table: {
        headerBg: 'transparent',
        headerColor: getCSSVariable('--table-header-text-color') || '#8D8D8D',
        borderColor: getCSSVariable('--border-color') || '#E7E7E7',
      },
      Select: {
        borderRadius: 20,
        borderRadiusLG: 20,
        borderRadiusSM: 20,
        optionPadding: '8px 12px',
      },
      Checkbox: {
        colorBorder: '#8c8c8c',
      },
    },
  };
};
